import axios from 'axios'

const apiClient = axios.create({
  baseURL: import.meta.env.VITE_API_URL || 'http://localhost:8000/api/v1',
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
  withCredentials: true, // Important for Sanctum
})

// Request interceptor - Add auth token
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('auth_token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Response interceptor - Handle errors
apiClient.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    if (error.response) {
      // Handle 401 Unauthorized - clear auth but don't redirect on public pages
      if (error.response.status === 401) {
        localStorage.removeItem('auth_token')
        localStorage.removeItem('user')

        // Only redirect to login if on a protected route (dashboard pages)
        // Don't redirect on public pages like /book, /services, etc.
        const currentPath = window.location.pathname
        const protectedPaths = ['/dashboard']
        const isProtectedRoute = protectedPaths.some(path => currentPath.startsWith(path))

        if (isProtectedRoute) {
          window.location.href = '/login'
        }
      }

      // Handle 422 Validation errors - return error data
      if (error.response.status === 422) {
        return Promise.reject(error.response.data)
      }
    }

    return Promise.reject(error)
  }
)

export default apiClient

